import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authToken = localStorage.getItem('authToken');
  // If the user is not authenticated, redirect to the login page
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }
  // If the user is authenticated, render the children (protected component)
  return <>{children}</>;
};

interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

export const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  // If the user is not authenticated or is not an admin user, redirect to the dashboard
  if (!localStorage.getItem('authToken') || localStorage.getItem('accountType') !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }
  // Else render the children (protected admin only component)
  return <>{children}</>;
};

interface AdminOnlyComponentProps {
  children: React.ReactNode;
}

export const AdminOnlyComponent: React.FC<AdminOnlyComponentProps> = ({ children }) => {
  // If the user account type is ADMIN, render the children (admin-only component)
  return <>{localStorage.getItem('accountType') === 'ADMIN' ? children : <div />}</>;
};
